// extracted by mini-css-extract-plugin
export default {"table":"table_table__JDE4u","noData":"table_noData__Bim-y"};